import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ReactiveFormsModule } from '@angular/forms';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { LoaderModule } from '@app/shared/loader/loader.module';
import { ByocMissionComponent } from './mission.component';
import { ByocMissionStepGeneralComponent } from './step/general/general.component';
import { ByocMissionStepCourseComponent } from './step/course/course.component';
import { ByocMissionStepCourseListComponent } from './step/course/list/list.component';
import { FormsModule } from '@app/shared/forms/forms.module';
import { DirectiveCourseModule } from '../course/directive/directive-course.module';
import { ByocMissionStepPositionComponent } from './step/position/byoc-mission-step-position/byoc-mission-step-position.component';
import { ByocMissionStepListComponent } from './step/position/byoc-mission-step-list/byoc-mission-step-list.component';
import { SharedModule } from '@app/shared';
import { DataTestModule } from '@app/shared/directive/data-test';
import { PerfectScrollbarModule } from '@app/shared/perfect-scrollbar/perfect-scrollbar.module';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        TranslateModule,
        ReactiveFormsModule,
        InlineSVGModule,
        NgbTooltipModule,
        DirectiveCourseModule,
        LoaderModule,
        FormsModule,
        SharedModule,
        DataTestModule,
        PerfectScrollbarModule,
    ],
    declarations: [
        ByocMissionComponent,
        ByocMissionStepGeneralComponent,
        ByocMissionStepCourseComponent,
        ByocMissionStepCourseListComponent,
        ByocMissionStepPositionComponent,
        ByocMissionStepListComponent,
    ],
})
export class ByocPopupMissionModule {}
